// Data the editor needs from the app (for chips and autocomplete), provided via a getter so the
// editor never has to be rebuilt when members/labels/collections change.
import { Facet } from "@codemirror/state";
import type { Actor } from "../api/types";

export interface EditorContextData {
  members: Actor[];
  labels: string[];
  collections: string[];
  /** Task anchor → item id (Rich mode "open task" links); undefined = unknown / unsupported. */
  anchors?: Map<string, string>;
  /** Opens an item (modal) by id. */
  openItem?: (itemId: string) => void;
  /** Today's date provider; overridable for tests. */
  now?: () => Date;
}

export type EditorContextGetter = () => EditorContextData;

export const editorContext = Facet.define<EditorContextGetter, EditorContextGetter>({
  combine: (values) => values[values.length - 1] ?? (() => ({ members: [], labels: [], collections: [] })),
});
